export const REDUX_PERSIST_KEY = 'persist:root'
export const PREVIOUS_PATHNAME_KEY = 'iframe_prvious_pathname'
